import { useMutation, UseMutationOptions } from 'react-query'
import { AxiosError } from 'axios'
import axios from 'axios'
import { useAuth0 } from 'app/Auth'
import { ImportSurgeriesPayload, ImportSurgeriesResponse } from './types'

const importSurgeriesMutationFn = async (
  payload: ImportSurgeriesPayload,
  getAccessToken: () => Promise<string> // Pass getAccessToken function
): Promise<ImportSurgeriesResponse> => {
  const formData = new FormData()
  formData.append('file', payload.file)
  formData.append('anonymous', String(payload.anonymous))

  const token = await getAccessToken()
  const REPORTS_URL = process.env.REACT_APP_REPORTS_URL

  if (!REPORTS_URL) {
    throw new Error(
      'REACT_APP_REPORTS_URL is not defined in environment variables.'
    )
  }

  const response = await axios.post<ImportSurgeriesResponse>(
    `${REPORTS_URL}api/v1/import/surgeries`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}

export const useImportSurgeries = (
  options?: UseMutationOptions<
    ImportSurgeriesResponse,
    AxiosError, // Use AxiosError for error type
    ImportSurgeriesPayload
  >
) => {
  const { getAccessToken } = useAuth0()

  return useMutation<
    ImportSurgeriesResponse,
    AxiosError,
    ImportSurgeriesPayload
  >(
    (data: ImportSurgeriesPayload) =>
      importSurgeriesMutationFn(data, getAccessToken),
    options
  )
}
